import { API_USER_PROFILE_OPTION_PREFIX } from '@shared/config/api/api-prefixes';
import { userProfileOptionBaseApi } from './base';
import { UserProfileOptionDataRequest, UserProfileOptionsDataResponse } from './user-profile-option-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { isEqualParameters } from '@shared/lib/utils/is-equal-parameters/is-equal-parameters';

export const userProfileOptionApi = userProfileOptionBaseApi.injectEndpoints({
    endpoints: (build) => ({
        userProfileOptionsList: build.query<UserProfileOptionsDataResponse, UserProfileOptionDataRequest>({
            query: (parameters) => `${API_USER_PROFILE_OPTION_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['UserProfileOptionList'],
        }),

        userProfileOptionsInfinityList: build.query<UserProfileOptionsDataResponse, UserProfileOptionDataRequest>({
            query: (parameters) => `${API_USER_PROFILE_OPTION_PREFIX}${queryParametersToString({ ...parameters })}`,
            serializeQueryArgs: (params) => {
                return `${params.endpointName}_${params.queryArgs.search}`;
            },
            merge: (currentCache, newItems) => {
                if (newItems.skip) {
                    currentCache.items.push(...newItems.items);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
            },
        }),

        userProfileOptionsPublicList: build.query<UserProfileOptionsDataResponse, UserProfileOptionDataRequest>({
            query: (parameters) =>
                `${API_USER_PROFILE_OPTION_PREFIX}/public${queryParametersToString({ ...parameters })}`,
            providesTags: ['UserProfileOptionList'],
        }),

        userProfileOptionsPublicInfinityList: build.query<UserProfileOptionsDataResponse, UserProfileOptionDataRequest>(
            {
                query: (parameters) =>
                    `${API_USER_PROFILE_OPTION_PREFIX}/public${queryParametersToString({ ...parameters })}`,
                serializeQueryArgs: (params) => {
                    return `${params.endpointName}_${params.queryArgs.search}`;
                },
                merge: (currentCache, newItems) => {
                    if (newItems.skip) {
                        currentCache.items.push(...newItems.items);
                    }
                },
                forceRefetch({ currentArg, previousArg }) {
                    return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
                },
            }
        ),
    }),
});

export const {
    useLazyUserProfileOptionsListQuery,
    useLazyUserProfileOptionsPublicListQuery,
    useUserProfileOptionsInfinityListQuery,
    useUserProfileOptionsPublicInfinityListQuery,
} = userProfileOptionApi;
